export default __webpack_public_path__ + "static/media/icon-tableau-blanc.aebee5ff.svg";